import { Link } from "react-router-dom";
import { mangaWorks } from "@/mocks/manga";

const fitnessCoach = mangaWorks.find((w) => w.id === "fitness-coach") ?? mangaWorks[0];

export default function CtaBand() {
  return (
    <section className="bg-background-50 pb-12 md:pb-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-lg bg-gradient-to-r from-primary-600 via-primary-500 to-accent-500 px-6 py-12 text-center md:px-10 md:py-16">
          <div className="absolute -left-10 -top-10 h-40 w-40 rounded-full bg-background-50/10"></div>
          <div className="absolute -bottom-14 -right-10 h-48 w-48 rounded-full bg-background-50/10"></div>
          <div className="relative z-10 mx-auto max-w-2xl">
            <h2 className="font-heading text-2xl font-black leading-snug text-background-50 md:text-3xl">
              今天，就从《健身教练》第1话开始蜕变
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-50/85 md:text-base">
              不用充值、不用等待，注册都不需要。打开就开练，跟着林小北一起流汗、一起成长，见证普通人逆袭成健身达人的燃力故事。
            </p>
            <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link
                to={`/reader/${fitnessCoach.id}/1`}
                className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-background-50 px-8 py-3 text-sm font-bold text-primary-600 transition-colors hover:bg-background-100 sm:w-auto"
              >
                <i className="ri-flashlight-line mr-2 text-base"></i>
                马上开读
              </Link>
              <Link
                to="/category/all"
                className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md border border-background-50/50 px-8 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-background-50/10 sm:w-auto"
              >
                去漫画大全逛一逛
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}